import React from 'react'
import Link from 'gatsby-link'
import Image from 'gatsby-image'
import styled from 'styled-components'
import BuildingAnimation from '../components/buildingAnimation'
import Approach from '../components/approach'
import Slide from 'react-reveal/Slide'
import { HelmetDatoCms } from 'gatsby-source-datocms'

const PageWrapper = styled.div`
  .header {
    position: relative;
    .gatsby-image-outer-wrapper {
      z-index: 1;
      position: absolute !important;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .gatsby-image-wrapper {
        height: 100%;

        img {
          object-position: bottom center !important;
          @media screen and (min-width: 940px) {
            object-fit: contain !important;
            object-position: bottom center !important;
          }
        }
      }
    }

    .columns {
      z-index: 2;
      position: relative;
    }
  }

  .packages {
    .card {
      box-shadow: 0px 0px 0px transparent;
      transition: box-shadow 300ms ease;
      &:hover {
        box-shadow: 15px 15px 25px rgba(1, 17, 23, 0.6);
      }
    }
    position: relative;
    .gatsby-image-outer-wrapper {
      position: absolute !important;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      .gatsby-image-wrapper {
        height: 100%;
      }
    }
  }

  .plan {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .card {
    border-radius: 10px;
    .card-content {
      border-radius: 0px 0px 10px 10px;
    }
  }

  .house-container {
    position: relative;

    img:not(:first-child) {
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .bars {
    .gatsby-image-outer-wrapper {
      margin-top: 50px;
      display: flex;
      justify-content: center;
    }
  }
`

const AboutPage = ({ data }) => (
  <PageWrapper>
    <HelmetDatoCms seo={data.datoCmsAbout.seoMetaTags} />
    <section className="section header is-medium has-background-primary">
      <div className="columns is-centered">
        <div className="column is-half-desktop is-two-thirds-tablet has-text-centered">
          <h1 className="title is-size-1 is-uppercase has-text-weight-bold has-text-dark is-uppercase">
            Creative Agency
          </h1>
          <p className="is-size-5 has-text-dark has-text-weight-semibold">
            Our focus is on delivering measurable results for small and
            mid-sized businesses. We use proven digital marketing techniques
            tailored for each business.
          </p>
        </div>
      </div>
      <Image sizes={data.datoCmsAbout.headerImage.sizes} />
    </section>
    <section className="section has-background-darker">
      <div className="container">
        <div className="">
          <div className="columns is-centered">
            <div className="column is-half">
              <h2 className="title is-size-1 is-uppercase has-text-white has-text-centered">
                Our Approach
              </h2>
            </div>
          </div>
        </div>

        <Approach />

        <div className="">
          <div className="columns is-centered">
            <div
              className="column is-8 bars"
              style={{ padding: '50px 0px 0px 0px' }}
            >
              <h3 className="title has-text-centered has-text-white">
                What does this mean for you?
              </h3>
              <p className="has-text-white has-text-centered has-text-weight-semibold">
                It means you can run your business without having to worry about
                website development, marketing collateral, or online
                advertising. We strategize and carry out marketing campaigns to
                grow your business online and adjust to your needs. We give you
                the power to focus on what you do best, growing your business.
              </p>
              <Image
                resolutions={data.datoCmsAbout.approachBottomImage.resolutions}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* <section className="section packages is-medium has-background-dark"> */}
    {/*   <Image sizes={data.datoCmsAbout.sectionImage.sizes} /> */}
    {/*   <div className="container"> */}
    {/*     <div className="columns is-centered"> */}
    {/*       <div */}
    {/*         className="column is-half has-text-centered" */}
    {/*         style={{ zIndex: 1 }} */}
    {/*       > */}
    {/*         <h2 className="title is-size-1 has-text-white is-uppercase"> */}
    {/*           Packages */}
    {/*         </h2> */}
    {/*         <p className="subtitle is-size-5 has-text-white"> */}
    {/*           We’ve distilled our service offerings to two basic packagings that */}
    {/*           provide the basics to grow and expand small to mid-sized */}
    {/*           businesses. */}
    {/*         </p> */}
    {/*       </div> */}
    {/*     </div> */}
    {/*     <div className="columns"> */}
    {/*       <div className="column is-6 plan"> */}
    {/*         <div className="card"> */}
    {/*           <div className="card-content"> */}
    {/*             <h2 className="pv1 title has-text-centered has-text-dark"> */}
    {/*               Foundations Plan */}
    {/*             </h2> */}
    {/*             <p className="pv1 subtitle has-text-centered has-text-dark"> */}
    {/*               The basic digital marketing every business should be doing. */}
    {/*             </p> */}
    {/*             <p className="pv1 title has-text-centered has-text-primary"> */}
    {/*               $2500 + $250/mo */}
    {/*             </p> */}
    {/*           </div> */}
    {/*           <div className="card-content content has-background-primary-muted"> */}
    {/*             <ul className="has-text-dark"> */}
    {/*               <li>Personalized Branding</li> */}
    {/*               <li>Website Design</li> */}
    {/*               <li>Website Development</li> */}
    {/*               <li>Website Hosting</li> */}
    {/*               <li>SEO</li> */}
    {/*               <li>Online Advertising</li> */}
    {/*             </ul> */}
    {/*           </div> */}
    {/*         </div> */}
    {/*       </div> */}
    {/*       <div className="column is-6 plan"> */}
    {/*         <div className="card"> */}
    {/*           <div className="card-content"> */}
    {/*             <h2 className="pv1 title has-text-centered has-text-dark"> */}
    {/*               Business Plan */}
    {/*             </h2> */}
    {/*             <p className="pv1 subtitle has-text-centered has-text-dark"> */}
    {/*               Take your lead generation and branding to the next level. */}
    {/*             </p> */}
    {/*             <p className="pv1 title has-text-centered has-text-primary"> */}
    {/*               $5000 + $1250/mo */}
    {/*             </p> */}
    {/*           </div> */}
    {/*           <div className="card-content content has-background-primary-muted"> */}
    {/*             <p className="has-text-weight-bold has-text-dark"> */}
    {/*               All Foundations Plan, Plus: */}
    {/*             </p> */}
    {/*             <ul className="has-text-dark"> */}
    {/*               <li>Targeted Online Ad Campaign</li> */}
    {/*               <li>Lead Conversion</li> */}
    {/*               <li>Marketing Strategy</li> */}
    {/*               <li>Marketing Design</li> */}
    {/*               <li>Brand Strategy</li> */}
    {/*             </ul> */}
    {/*           </div> */}
    {/*         </div> */}
    {/*       </div> */}
    {/*     </div> */}
    {/*     <p */}
    {/*       className="m3 is-size-5 has-text-centered has-text-white" */}
    {/*       style={{ marginTop: '2rem' }} */}
    {/*     > */}
    {/*       Need custom enterprise web solutions?{' '} */}
    {/*       <Link className="has-text-primary" to="/contact"> */}
    {/*         Contact Us */}
    {/*       </Link> */}
    {/*     </p> */}
    {/*  */}
    {/*     <p className="is-size-7 has-text-white has-text-centered is-marginless is-paddingless"> */}
    {/*       *All pricing is subject to change based on individual requirements */}
    {/*     </p> */}
    {/*   </div> */}
    {/* </section> */}
  </PageWrapper>
)

export default AboutPage

export const AboutQuery = graphql`
  query AboutQuery {
    datoCmsAbout {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      headerImage {
        id
        sizes(maxWidth: 1600) {
          ...GatsbyDatoCmsSizes
        }
      }
      sectionImage {
        id
        sizes(maxWidth: 1600) {
          ...GatsbyDatoCmsSizes
        }
      }
      approachBottomImage {
        id
        resolutions(width: 300) {
          ...GatsbyDatoCmsResolutions
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about.js